import AUStates from './tr-TR/AU-states.json.js';
import CAStates from './tr-TR/CA-states.json.js';
import CNStates from './tr-TR/CN-states.json.js';
import CompanySize from './tr-TR/company-size.json.js';
import CompanyType from './tr-TR/company-type.json.js';
import countries from './tr-TR/countries.json.js';
import DEStates from './tr-TR/DE-states.json.js';
import HKStates from './tr-TR/HK-states.json.js';
import INStates from './tr-TR/IN-states.json.js';
import industry from './tr-TR/industry.json.js';
import interests from './tr-TR/interests.json.js';
import jobRole from './tr-TR/job-role.json.js';
import levelOfAWSUsage from './tr-TR/level-of-aws-usage.json.js';
import projectTimeline from './tr-TR/project-timeline.json.js';
import PTStates from './tr-TR/PT-states.json.js';
import USStates from './tr-TR/US-states.json.js';
import useCase from './tr-TR/use-case.json.js';
import languagePreference from './tr-TR/language-preference.json.js';
import Navatar from '../tr-TR/translation.json.js';

const dropdownsData = {
    ...AUStates,
    ...CAStates,
    ...CNStates,
    ...CompanySize,
    ...CompanyType,
    ...countries,
    ...DEStates,
    ...HKStates,
    ...INStates,
    ...industry,
    ...interests,
    ...jobRole,
    ...levelOfAWSUsage,
    ...projectTimeline,
    ...PTStates,
    ...USStates,
    ...useCase,
    ...Navatar.translation,
    ...languagePreference,
};

export { dropdownsData as default };
